module.exports = __webpack_public_path__ + "react-development.H2Icv-Ft.svg";